import {SponsoredContentSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  originClick,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk';
import {useTrackOriginClick, useTrackPromotion} from '@aboutyou/tracking';
import {
  BaseSlider,
  MIN_PRODUCTS_PER_TEASER_CARD,
  TeaserCard,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  ButtonWrapper,
  SponsoredPlacementHeader,
} from '../SponsoredPlacement/SponsoredPlacementHeader';

interface SearchSuggestSponsoredSliderProps {
  campaigns: SponsoredContentSection[];
}

const MAX_CAMPAIGNS = 3;

export const SearchSuggestSponsoredSlider: React.FC<
  SearchSuggestSponsoredSliderProps & {
    className?: string;
    hideButtonControls?: boolean;
    onTeaserClick?: () => void;
  }
> = ({campaigns, className, hideButtonControls = false, onTeaserClick}) => {
  const {t} = useTranslation();
  const validCampaigns = campaigns
    .filter(
      campaign => campaign.productImages.length >= MIN_PRODUCTS_PER_TEASER_CARD,
    )
    .slice(0, MAX_CAMPAIGNS);

  return (
    <BaseSlider<SponsoredContentSection>
      items={validCampaigns}
      getItemKey={campaign => campaign.promotionTracking.promotionId}
      renderSlide={campaign => (
        <TrackedCard campaign={campaign} onCardClick={onTeaserClick} />
      )}
      className={className}
      hideButtonControls={hideButtonControls}
      initialSlideIndex={0}
      dataTestId="searchSuggestSponsoredSlider"
      prevArrowAriaLabel={t('Go to previous sponsored slide')}
      nextArrowAriaLabel={t('Go to next sponsored slide')}
    />
  );
};

const TrackedCard: React.FC<{
  campaign: SponsoredContentSection;
  onCardClick?: () => void;
}> = ({campaign, onCardClick}) => {
  const trackOriginClick = useTrackOriginClick();
  const trackPromotion = useTrackPromotion();
  return (
    <StyledTeaserCard
      campaign={campaign}
      onCardClick={() => {
        onCardClick?.();

        trackOriginClick(
          campaign.promotionTracking.locationId as originClick,
        )();

        trackPromotion({
          promotion: {
            promotionTracker: campaign.promotionTracking,
            source: TrackingPromotionCreative.GenericPromotion,
          },
          streamPosition: 0,
          actionType: 'click',
        });
      }}
      header={
        <StyledSponsoredHeader
          sponsored={campaign.sponsored}
          promotionTracking={campaign.promotionTracking}
        />
      }
    />
  );
};

const StyledTeaserCard = styled(TeaserCard)`
  ${ButtonWrapper} {
    position: absolute;
    top: 0;
    right: 10px;
    display: flex;
    justify-content: flex-end;
  }
`;

const StyledSponsoredHeader = styled(SponsoredPlacementHeader)`
  --spacing: 0px;
  position: relative;
`;
